import flashImg from '../components/atomic/buttons/button/flash.png';
import pageIndexBackgroundImg from '../components/atomic/buttons/page_paginator/page_index_background.png';
import dialogBackgroundImg from '../components/atomic/dialog/dialog_popup/dialog_background.png';
import titleHeaderBackgroundImg from '../components/atomic/dialog/dialog_popup/title_header_background.png';
import welcome1CharacterImg from './character/character.png';
import welcome1ButtonTextImg from './button/text.png';
import welcome1TitleTextSvg from './texts/title_text.svg';
import welcome1DescriptionTextSvg from './texts/description_text.svg';
import welcome2CharacterImg from '../welcome_delivery_2/character/character.png';
import welcome2ButtonTextImg from '../welcome_delivery_2/button/button_text.png';
import welcome2MailsDecorImg from '../welcome_delivery_2/mails_decor/mails_decor.png';
import welcome2HeaderTextSvg from '../welcome_delivery_2/texts/header_text.svg';
import welcome2DescriptionTextSvg from '../welcome_delivery_2/texts/description_text.svg';

export function getWelcomeAssetUrls(): string[] {
  return [
    dialogBackgroundImg,
    titleHeaderBackgroundImg,
    pageIndexBackgroundImg,
    flashImg,
    welcome1CharacterImg,
    welcome1ButtonTextImg,
    welcome1TitleTextSvg,
    welcome1DescriptionTextSvg,
    welcome2CharacterImg,
    welcome2ButtonTextImg,
    welcome2MailsDecorImg,
    welcome2HeaderTextSvg,
    welcome2DescriptionTextSvg,
  ];
}
